import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { ReactNode } from "react";

import {
  fixedWidth,
  mediaQueryIsDesktop,
  mediaQueryIsMobile,
} from "~/lib/client/design";

export const PC_BENTO_ITEM_GAP_SIZE = 12.5 as const;

const BentoItemRow = ({ children }: { children: ReactNode }) => {
  return <Container>{children}</Container>;
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 auto;

  ${mediaQueryIsMobile(css`
    ${fixedWidth("365px")};
    justify-content: space-between;
  `)}

  ${mediaQueryIsDesktop(css`
    ${fixedWidth("1200px")};
    gap: ${PC_BENTO_ITEM_GAP_SIZE}px;
  `)}
`;

export default BentoItemRow;
